import { Ref } from 'vue';
import { useEnvStore } from '../core/useEnvStore';
import type { GridRawRowDataType, GridTableInstance } from '../../modernGrid.types';

export const useSortReset = <RowDataType extends GridRawRowDataType>({
  table,
  envKey,
  useDashboardStore = false,
}: {
  table: Ref<GridTableInstance<RowDataType> | undefined>;
  envKey: Ref<string | undefined>;
  useDashboardStore?: boolean;
}) => {
  const { getEnv, saveEnv } = useEnvStore(useDashboardStore);

  const resetSort = async () => {
    table.value?.resetSorting();

    try {
      const key = envKey.value;
      if (!key) return;

      const envData = getEnv(key);
      if (!envData?.sorting?.length) return;

      await saveEnv(key, { ...envData, sorting: [] });
    } catch (e) {
      console.error('[useSortReset] env save failed:', e);
    }
  };

  return { resetSort };
};
